import { createAction, props } from '@ngrx/store';

const GET_FILE_ATTACHMENTS = '[FileAttachments] Get FileAttachments';
const GET_FILE_ATTACHMENTS_SEARCH = '[FileAttachments] Get FileAttachments With Search';
const GET_FILE_ATTACHMENTS_SORTING = '[FileAttachments] Get FileAttachments With Sorting';
const SAVE_FILE_ATTACHMENTS = '[FileAttachments] Save FileAttachments';
const SAVE_FILE_ATTACHMENTS_ORDER = '[FileAttachments] Save FileAttachments Order';
const SET_FILE_ATTACHMENTS = '[FileAttachments] Set FileAttachments';
const UPDATE_FILE_ATTACHMENTS = '[FileAttachments] Update FileAttachments';
const DELETE_FILE_ATTACHMENTS = '[FileAttachments] Delete FileAttachments';

const getFileAttachments = createAction(GET_FILE_ATTACHMENTS, props<{ apiConstants: any }>());
const getFileAttachmentsWithSearch = createAction(
  GET_FILE_ATTACHMENTS_SEARCH,
  props<{ apiConstants: any; searchFields: any }>()
);
const getFileAttachmentsWithSorting = createAction(
  GET_FILE_ATTACHMENTS_SORTING,
  props<{ apiConstants: any; params: any }>()
);

const setFileAttachments = createAction(SET_FILE_ATTACHMENTS, props<{ fileAttachmentsDataOrder: any }>());

const saveFileAttachments = createAction(
  SAVE_FILE_ATTACHMENTS,
  props<{ saveapiConstants: any; fileAttachmentsData: any; sidToBeSent: any; actionType?: any }>()
);

const saveFileAttachmentsForOrder = createAction(
  SAVE_FILE_ATTACHMENTS_ORDER,
  props<{ saveapiConstants: any; fileAttachmentsData: any; itemType: any; sidToBeSent: any; actionType?: any }>()
);

const updateFileAttachments = createAction(UPDATE_FILE_ATTACHMENTS, props<{ fileAttachmentsData: any }>());

const deleteFileAttachments = createAction(
  DELETE_FILE_ATTACHMENTS,
  props<{ apiConstants: any; fileAttachmentsId: string }>()
);

export {
  getFileAttachments,
  setFileAttachments,
  saveFileAttachments,
  updateFileAttachments,
  deleteFileAttachments,
  getFileAttachmentsWithSearch,
  getFileAttachmentsWithSorting,
  saveFileAttachmentsForOrder
};
